export default __webpack_public_path__ + "static/media/Factory_Customer-Story-Telecomms-Comp.819423c0.jpg";